module.exports = __webpack_public_path__ + "27bca04bdea6c568fbfe4958e70085d8.pdf";